import { Box, BoxProps } from '@primer/react';
import Text from '../../../components/ui/text';
interface IFormBlockProps extends BoxProps {
    caption: string
}
const FormBlock = (props: IFormBlockProps) => {
    return (
        <Box sx={{ display: "grid", gap: 2 }}>
            <Box sx={{ display: "grid", gap: 2, alignItems: "center", gridTemplateColumns: "1fr" }}>
                {/* <Box sx={{
                    display: "flex",
                    flexDirection: "column"
                }}>
                    <Box sx={{
                        backgroundColor: "rgb(5, 12, 156)",
                        width: "4px",
                        borderRadius: 2,
                        flex: 1,
                        pt: 1,
                        pb: 1
                    }}>
                        &nbsp;
                    </Box>
                </Box> */}
                <Text text={props.caption} sx={{
                    // fontSize: 16,
                    fontWeight: "bolder",
                    // color: "rgb(5, 12, 156)",
                    color: "fg.muted",
                    // textTransform: "uppercase",
                    
                }} />
            </Box>
            <Box>
                {props.children}
            </Box>
        </Box>
    );
};

export default FormBlock;